export default __webpack_public_path__ + "static/media/F0003.d54d019f.png";